import { registerRootComponent } from 'expo';
import App from './App';
import { en, registerTranslation } from 'react-native-paper-dates';
import environment from './environment';
registerTranslation('en', en);

if (environment.ENV === 'production') {
    console.log = function () { }; // Disable log
    console.warn = function () { }; // Disable warn
    console.info = function () { }; // Disable info
    console.debug = function () { }; // Also disable debug if used
}

registerRootComponent(App);
